// extracted by mini-css-extract-plugin
module.exports = {"highlight":"style__highlight__GQHkQ"};